import { Currency } from 'ha/constants/Currencies';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Listing } from './types/Listing';

interface Query {
  bookablePeriods?: Listing['bookablePeriods'];
  currency?: Currency;
  /**
   * @description comma-separated string with possible values: `exclusions`, `exclusionsExtended`, `bookablePeriods`, `conversationCounters`, `lastMonthConversationCount`, `videos`, `costs`
   */
  expand?: string;
  from?: string;
  limit?: number;
  maxPrice?: number;
  minPrice?: number;
  offset?: number;
  orderBy?: string;
  query?: string;
  to?: string;
  userId: number;
  ids?: string;
  uuids?: string;
  withCroppedPhotos?: boolean;
  withListingState?: string;
  withPhotos?: string;
}

export interface ListingsResponse {
  count: number;
  listings: Listing[];
}

export default (makeCall: MakeCall) => (query: Query) =>
  makeCall<ListingsResponse>('GET', `/api/v2/listings`, { query });
